import React, { useContext } from "react";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const ChairApproval = ({ chairApproval, sampleDisposal, handleChange, xplans, required }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="chairApproval" className="planField">
            <GroupBDRBiologists />
            <FormControl required={required.includes("chairApproval")}>
                <FormLabel className="planRadioTitle">
                    {sampleDisposal === "No" ? xplanLabels.chairApproval : xplanLabels.chairApproval2}
                </FormLabel>
                <RadioGroup
                    name="chairApproval"
                    label={sampleDisposal === "No" ? xplanLabels.chairApproval : xplanLabels.chairApproval2}
                    value={chairApproval}
                    onChange={(e) => handleChange("chairApproval", e.target.value)}
                    row
                >
                    <FormControlLabel
                        value="Yes"
                        control={<Radio disabled={!canEdit} />}
                        label="Yes"
                    />
                    <FormControlLabel
                        value="No"
                        control={<Radio disabled={!canEdit} />}
                        label="No"
                    />
                </RadioGroup>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"chairApproval"} />}
        </div>
    );
};

export default ChairApproval;